import { DtAnCreditapplicationLibModule } from './../../../dt-an-creditapplication-lib/src/lib/dt-an-creditapplication-lib.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { TestComponent } from 'projects/dt-an-creditapplication-lib/src/tests/next-component.service.mock';

import {DtAnPricedetailsLibModule} from '@autonation/dt-an-pricedetails-lib';
import { NotificationModule } from '@autonation/dt-an-components-lib/notification-modal';

@NgModule({ declarations: [AppComponent, TestComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        CommonModule,
        DtAnPricedetailsLibModule,
        DtAnCreditapplicationLibModule.forRoot({
            SitecoreDomain: ''
        }),
        NotificationModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppModule {}
